import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Guard da página "Minha Semana": exige só estar logado.
// A allowlist de quem pode ler/gravar é aplicada no backend (retorna 403),
// e a própria página mostra a mensagem de acesso restrito nesse caso.
const ConsultorRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Espera da autenticação: esqueleto no desenho de .ui-pagina (título, abas e
    // uma lista em .ui-card), com a .skel do kit — brilho de 1.4s que para com
    // prefers-reduced-motion. A forma final ainda não é conhecida (a rota só
    // decide depois do login), então é a forma mais comum do painel.
    return (
      <div
        className="min-h-screen"
        style={{ background: 'var(--care-bg-canvas)' }}
        role="status"
        aria-busy="true"
      >
        <span className="sr-only">Carregando…</span>
        <div aria-hidden="true" className="ui-pagina">
          <span className="skel" style={{ display: 'block', height: 30, width: '32%' }} />
          <span className="skel" style={{ display: 'block', height: 12, width: '48%', marginTop: 'var(--care-space-4)' }} />
          <div className="ui-trilho" data-gap="7" style={{ marginTop: 'var(--care-space-9)', marginBottom: 'var(--care-space-8)' }}>
            {[72, 88, 64, 80].map((w) => (
              <span key={w} className="skel" style={{ display: 'block', height: 12, width: w }} />
            ))}
          </div>
          <div className="ui-card">
            <div className="ui-carregando ui-linhas">
              {[0, 1, 2].map((i) => (
                <div key={i} className="ui-linha" data-i={i}>
                  <span className="ui-carregando__ponto skel" />
                  <span className="ui-carregando__nome skel" />
                  <span className="ui-carregando__meta skel" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    // Preserva o destino original (inclui a query, ex: ?year=&week= do link do e-mail)
    // para o Login voltar pra cá depois de autenticar.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
};

export default ConsultorRoute;
